module.exports = "<div class=\"col-12 col-md-6 col-lg-4 flex-column-flexgrow--1\">\n  <div class=\"ft-b txt-center flexgrow--0\">- {{title}} -</div>\n  <ul class=\"bd-right bd-bottom p-left-0\">\n    {{> rows}}\n  </ul>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/guideline/templates/config_section.html
// module id = 131
// module chunks = 0